import type {IRootMachineSnapshot} from '../machines/rootMachine/rootMachine';


export const selectBrandSettings = (state: IRootMachineSnapshot) => {
  return (
    state.context.eventDetails?.brand_settings ||
    state.context.eventTemplate?.brand_settings
  );
};
